/**
 * Created by JIocb on 20.06.2017.
 */
namespace Factive.Game {
    import Signal = Factive.Core.Signal.Signal;
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import Slot = dragonBones.Slot;

    export class ScoreTableView {

        private _view:dragonBones.Armature;
        private _model:ScoreTableModel;
        private _renderers:Array<ScoreTableRowView> = [];
        private _dc: Factive.Core.DependenciesContainer;
        public signal:Signal = new Signal();
        private _totalScoreText: PIXI.Text;
        private _hint:ScoreTableRowHintView;
        private _hintLayer: PIXI.Container;
        private _assetScale: number;
        private _scale: number;
        private _aspectRatio:string;

        constructor(view:dragonBones.Armature,model:ScoreTableModel,dc:DependenciesContainer,hintLayer:PIXI.Container,aspectRatio:string) {

            this._view = view;
            this._model = model;
            this._dc = dc;
            this._hintLayer = hintLayer;
            this._scale = view.display.transform.scale.x;
            this._assetScale = this._dc.get("AssetScale");
            this._aspectRatio = aspectRatio;
            this.build();

            this._model.signal.add(this.handleModelEvents,this);
        }

        private handleModelEvents(evt:string):void
        {
            if(evt == "updated")
            {
                this.update();
            }
        }

        public applyAspectRatio(aspectRatio:string):void
        {
            this._aspectRatio = aspectRatio;
        }

        private build():void
        {
            var keys = Object.keys(ScoreCombinationType)
            var l: number = keys.length * .5;
            for (var i: number = 0; i < l; i++)
            {
                var slot:Slot = this._view.getSlot("ResultTableRow"+i);
                if(slot)
                {
                    var renderer:ScoreTableRowView = new ScoreTableRowView(slot.childArmature,this._dc);
                    renderer.signal.add(this.handleEventsFromRenderer,this)
                    this._renderers[this._renderers.length] = renderer;
                }
            }

            var wrapper:PIXI.Container;

            for(i = 0; i <3; i++)
            {
                var title = new PIXI.Text("", <PIXI.TextStyle>{
                    fontFamily: 'Regular',
                    fontSize: 14* this._assetScale,
                    fill: '#FFFFFF',
                    align: "center"
                });

                title.anchor.set(.5,.5);
                //title.scale.x = title.scale.y = .5;
                title.text = "X"+(i+1);

                wrapper = new PIXI.Container();
                wrapper.addChild(title);
                this._view.getSlot("x"+(i+1).toString()+"_text_container").display = wrapper;

            }

            var totalTitle = new PIXI.Text("", <PIXI.TextStyle>{
                fontFamily: 'Bold',
                fontSize: 14* this._assetScale,
                fill: '#FFFFFF',
                align: "left"
            });


            totalTitle.text = this._dc.get("LocalizationManager").getText("total");
            // totalTitle.x = -this._view.display.width*.47;
            // totalTitle.y = this._view.display.height*.44;
            //totalTitle.scale.x = totalTitle.scale.y = .5;
            totalTitle.x = 10;
            wrapper = new PIXI.Container();
            wrapper.addChild(totalTitle);

            this._view.getSlot("title_total_score_text_container").display = wrapper;

            this._totalScoreText = new PIXI.Text("", <PIXI.TextStyle>{
                fontFamily: 'Bold',
                fontSize: 16* this._assetScale,
                fill: '#FFFFFF',
                align: "right"
            });
            this._totalScoreText.anchor.set(1,0);
            //this._totalScoreText.scale.x = this._totalScoreText.scale.y = .5;
            this._totalScoreText.y = -5;

            wrapper = new PIXI.Container();
            wrapper.addChild(this._totalScoreText);

            this._totalScoreText.text = "0";
            this._view.getSlot("total_score_text_container").display = wrapper;

            this.update();
        }

        public handleEventsFromRenderer(evt,data):void
        {
            switch (evt)
            {
                case "press":{ this.signal.dispatch("select_combination",data); break;}
                case "showHint":{ this.showHint(data.id); break;}
                case "hideHint":{ this.hideHint(); break;}
            }
        };

        private enableInput(value:boolean):void
        {
            var l:number = this._renderers.length;
            for(var i:number = 0; i < l; i++)
            {
                this._renderers[i].enableInput(value)
            }
        };

        public update():void
        {
            this.enableInput(!this._model.lock)

            var dataProvider:Array<Object> = this._model.getDataProvider();
            var l:number = dataProvider.length;

            for(var i:number = 0; i < l; i++)
            {
                this._renderers[i].setData(dataProvider[i]);
            }
            this._totalScoreText.text = this._model.totalScore.toString();

        }

        private removeHint():void {
            if(this._hint)
            {
                this._hintLayer.removeChild(this._hint);
                this._hint.destroy()
                this._hint = null;
            }
        }

        private showHint(id) {
            this.removeHint();

            this._hint = new ScoreTableRowHintView(this._dc);
            this._hint.initialize(id,this._aspectRatio);
            this._hintLayer.addChild(this._hint);

            var rndr:ScoreTableRowView = this._renderers[id];

            if(this._aspectRatio == "landscape") {
                this._hint.pivot.x = this._hint.width*.5;
                this._hint.x = this._view.display.x + (rndr.x - rndr.width * .5) * this._scale ;
            }
            else
            {
                this._hint.pivot.x = -this._hint.width*.5;
                this._hint.x = this._view.display.x;

            }
            this._hint.y = this._view.display.y + (rndr.y - rndr.height*.5)*this._scale;

            this._hint.scale.x = this._scale;
            this._hint.scale.y = this._scale;

            this._hint.visible = true;

        }

        private hideHint():void
        {
            if(this._hint)
            {
                this._hint.visible = false;
            }
        }

        public destroy()
        {
            this._model.signal.remove(this.handleModelEvents,this);
            this._model = null;

            for(var i:number = 0; i < this._renderers.length; i++)
            {

                this._renderers[i].signal.remove(this.handleEventsFromRenderer,this);
                this._renderers[i].destroy();
            }
            this._renderers = null;
            this.removeHint();
            this.signal.removeAll();
            this.signal = null;
            this._view = null;
            this._dc = null;
            this._totalScoreText.parent.removeChild(this._totalScoreText);
            this._totalScoreText = null;

            if(this._hint)
            {
                this._hintLayer.removeChild(this._hint);
                this._hint.destroy();
                this._hintLayer = null;
            }

        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/View/ScoreTableView.ts